<svelte:body on:item={put_item}/>
<script>
    import _ from 'lodash';
    import {validate_int} from '../../../validators.js';
    import {parameter, network} from '../../../stores.js';
    import {createEventDispatcher} from 'svelte';
    import {precision} from '../../../config.js';
    import RalColor from "../../parts/RalColor.svelte";
    import {decode, encode} from "../../../helpers";
    import DopMaterialList from "../../parts/DopMaterialList.svelte";
    import PodokonnikMaterialList from "../../parts/PodokonnikMaterialList.svelte";

    const dispatch = createEventDispatcher();
    const fixprecision = (value) => Math.ceil(value * precision) / precision;

    export let calc;
    export let options;

    export let put_item = async (e) => {
        let item = e.detail;

        if (item) {
            let fetched = await network.fetch_tovar(item.idTovar)
            let json = JSON.parse(decode(fetched.ind3))
            fetchData = await fetch();
            width.set(json.width)
            height.set(json.height)
            t = json.t
            kolvobok = json.kolvobok
            tip = json.tip
            tkan = json.tkan
            tkan2 = json.tkan2
            tkanboka = json.tkanboka
            tkanboka2 = json.tkanboka2
            components = json.components
            count.set(+item.quantity);
            comment.set(item.comment);
            change();
        }
    };

    let components = {}

    const fetch = async () => {
        let result = await network.fetch_data('Жалюзи Вальс', 'Вальс');
        let filtered = result.filter(el => el.name.startsWith('Жалюзи Вальс') && el.flag === '1')

// Создаем маппинг ткань -> доступные корнизы
        const tkanToCorniceMap = {};

        filtered.forEach(el => {
            const tkanName = el.ind1.trim().capitalize();
            const corniceName = el.ind2.trim().capitalize();

            if (!tkanToCorniceMap[tkanName]) {
                tkanToCorniceMap[tkanName] = new Set();
            }
            tkanToCorniceMap[tkanName].add(corniceName);
        });

        // Подготываем данные для селектов
        const colorTape = Array.from(new Set(filtered.map(el => el.ind1.trim().capitalize())))
            .filter(str => str !== '') // <-- добавь эту строку
            .sort((a, b) => a.localeCompare(b));

        const colorCornice = Array.from(new Set(filtered.map(el => el.ind2.trim().capitalize())))
            .sort((a, b) => a.localeCompare(b));

        return {
            name: _.groupBy(result, 'name'),
            color_tape: colorTape,
            color_cornice: colorCornice,
            tkanToCorniceMap: tkanToCorniceMap, // Маппинг для фильтрации
            result,
        }
    }

    let
        width = parameter('width', '2000'),
        height = parameter('height', '2300'),

        t = 'T1 (к упр)',
        kolvobok = 'нет',
        tip = 'Ручной лев',
        tkan = 'Полоса DT',
        tkan2 = 'DT-01',
        tkanboka = 'Полоса DT',
        tkanboka2 = 'DT-01',

        // другое
        comment = parameter('comment', ''),
        count = parameter('count', 1)
    ;

    let fetchData = fetch();
    let filteredCornice = []; // Отфильтрованные значения для второго селекта
    let filteredCornice2 = []; // Отфильтрованные значения для второго селекта
    /* let
         montage_item,
         montage_price = 1;*/

    // Инициализация отфильтрованных значений после загрузки данных
    const initializeFilteredValues = async () => {
        const data = await fetchData;
        if (data.color_cornice) {
            filteredCornice = [...data.color_cornice];
            filteredCornice2 = [...data.color_cornice];

            // Применяем фильтрацию если уже выбраны ткани
            if (tkan) {
                await filterCorniceOptions();
            }
            if (tkanboka) {
                await filterCorniceOptions2();
            }
        }
    };


    // Обработчик изменения первой ткани
    const handleTkanChange = (event) => {
        tkan = event.target.value;
        filterCorniceOptions();
        change();
    };

    // Обработчик изменения второй ткани
    const handleTkan2Change = (event) => {
        tkanboka2 = event.target.value;
        filterCorniceOptions2();
        change();
    };

    // Фильтрация опций для второго селекта
    const filterCorniceOptions = async () => {
        const data = await fetchData;

        if (!tkan || !data.tkanToCorniceMap) {
            // Если ничего не выбрано, показываем все корнизы
            filteredCornice = data.color_cornice || [];
            return;
        }

        // Получаем доступные корнизы для выбранной ткани
        const availableCornices = data.tkanToCorniceMap[tkan] || new Set();

        // Фильтруем опции корнизы
        filteredCornice = (data.color_cornice || []).filter(cornice =>
            availableCornices.has(cornice)
        );

        // Если есть доступные корнизы, выбираем первую
        if (filteredCornice.length > 0 && !availableCornices.has(tkan2)) {
            tkan2 = filteredCornice[0];
        } else if (filteredCornice.length === 0) {
            tkan2 = '';
        }
    };

    const filterCorniceOptions2 = async () => {
        const data = await fetchData;

        if (!tkanboka || !data.tkanToCorniceMap) {
            // Если ничего не выбрано, показываем все корнизы
            filteredCornice2 = data.color_cornice || [];
            return;
        }

        // Получаем доступные корнизы для выбранной ткани
        const availableCornices = data.tkanToCorniceMap[tkanboka] || new Set();

        // Фильтруем опции корнизы
        filteredCornice2 = (data.color_cornice || []).filter(cornice =>
            availableCornices.has(cornice)
        );

        // Если есть доступные корнизы, выбираем первую
        if (filteredCornice2.length > 0 && !availableCornices.has(tkanboka2)) {
            tkanboka2 = filteredCornice2[0];
        } else if (filteredCornice2.length === 0) {
            tkanboka2 = '';
        }
    };

    const handle_type = (is_manual, dops) => {
        components = {} // clean

       /* if (!is_manual) {
            let buf = dops.find((item) => item.name.trim().includes('Пульт'))

            components[buf.idTovar] = {count: 1}
        }*/
    }

    // расчёт стоимости
    const change = _.debounce(async () => {
        let data = await fetchData;

        let
            quantity = +$count,
            w = +$width,
            h = +$height
        ;



        let result = {
            type: 'Вальс',
            name: 'Вальс',
            subname: [
                $width + 'x' + $height, tip, t, (kolvobok == 'нет' ? ' ' : ', основная ') + tkan + ' - ' + tkan2, (kolvobok == 'нет' ? '' : kolvobok == 'Чередование' ? ' Чередование ' + tkanboka + ' ' + tkanboka2 : ', по бокам ' + kolvobok + ' ' + tkanboka + ' - ' + tkanboka2),
            ].join(', '),
            title: 'Жалюзи Вальс ' + [
                $width + 'x' + $height, tip, t, (kolvobok == 'нет' ? ' ' : ', основная ') + tkan + ' - ' + tkan2, (kolvobok == 'нет' ? '' : kolvobok == 'Чередование' ? ' Чередование ' + tkanboka + ' ' + tkanboka2  : ', по бокам ' + kolvobok + ' ' + tkanboka + ' - ' + tkanboka2),
            ].join(' '),
            params: {
                ind1: [tip, t, tkan, tkanboka, tkan2, tkanboka2].join(', '),
                ind2: '',
                ind3: encode(JSON.stringify({
                    width: $width,
                    height: $height,
                    t,
                    kolvobok,
                    tip,
                    tkan,
                    tkan2,
                    tkanboka,
                    tkanboka2,
                    components,
                })),
                ind4: w,
                ind5: h,
            },
            price: {rozn: 0, opt: 0, sebest: 0,},
            quantity,
            materials: {},
            comment: $comment,
            vStrukture: options.vStrukture || 137
        };

        let title_addons = []

        _.forEach(data.result, function (item) {
            let name = item.name.toLowerCase();

            let price = {rozn: 0, opt: 0, sebest: 0}
            let kolvo = 0;
            let nacenki = 1;


            if (name.includes("Мотор Novo 220В Вальс".toLowerCase()) && tip.includes("220В")) {
                kolvo = 1;
            }
            if (name.includes("Мотор Novo 220 АКБ Вальс".toLowerCase()) && tip.includes("АКБ")) {
                kolvo = 1;
            }

            if (name.includes("Плечики на вальс".toLowerCase())) {
                kolvo = Math.ceil(w / 110) * 2;
            }

            if (name.includes("Дублерин (клейкая лента)".toLowerCase())) {
                kolvo = (w / 110 * 2 + 1) * 420 / 1000;
            }

            if ((name.includes("бегунок"))&& tip.includes("Ручной")) {
                let {idTovar} = data.result.find((item) => item.name.toLowerCase().includes("металлические бегунки"))

                if (!components.hasOwnProperty(idTovar)) {
                    kolvo = Math.floor((w- 15 )/ 110);
                }
            }




            if (name.includes("Ткань".toLowerCase()) && tkan == item.ind1 && tkan2 == item.ind2 &&  !tip.includes('Карниз эл')) {
                kolvo = (Math.round(($width - 15) / 115) -1) * h / 1000;
            }


            if (name.includes("Веревка для вертикалки".toLowerCase()) && (tip == "Ручной лев" || tip == "Ручной прав")) {

                if(h*2-850>=1600 ){
                    kolvo = (w * 2 + h * 2 - 700) / 1000;
                }
                else{
                    kolvo = (w * 2 + h * 2 ) / 1000;
                }

            }
            if (name.includes("Нить".toLowerCase()) && (tip == "Ручной лев" || tip == "Ручной прав")) {
                kolvo = (w * 2 + h * 2 - 850) / 1000;
            }
            if (name.includes("Цепь металл".toLowerCase()) && (tip == "Ручной лев" || tip == "Ручной прав")) {

                if(h*2-850>=1600 ){
                    kolvo = ( h * 2 - 850) / 1000;
                }
                else{
                    kolvo = (1600 ) / 1000;
                }

            }


            if (name.includes("Вес цепи".toLowerCase()) && (tip == "Ручной лев" || tip == "Ручной прав")) {
                kolvo = 1;
            }


            if (name == 'Сборка системы вальс'.toLowerCase() ) {
                kolvo = (1).toFixed(3);
            }


            if (components.hasOwnProperty(item.idTovar)) {
                let edIzmer = item.edIzmer.length ? item.edIzmer : 'шт.'

                if (item.name.toLowerCase().includes("металлические бегунки")) {
                    kolvo = +components[item.idTovar]['count'];
                }
                else {
                    kolvo = +components[item.idTovar]['count'];
                }

                title_addons.push(`${item.name} - ${kolvo}/${edIzmer}`)
            }

            if (name.includes("жалюзи вальс") && tkan2 == item.ind2 && tkan == item.ind1) {

                if (w < 1000){
                    if (h < 1500){
                        kolvo = (1000 * 1500 / 1000000).toFixed(3);
                    }
                    else{
                        kolvo = (1000 * h / 1000000).toFixed(3);
                    }
                }
                else{
                    if (h < 1500){
                        kolvo = (w * 1500 / 1000000).toFixed(3);
                    }
                    else{
                        kolvo = (w * h / 1000000).toFixed(3);
                    }
                }

            }

            if ( h> 3000){
                nacenki=1.3;
            }

            if (kolvo) {

                price['rozn'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.price * (+item.flag) * nacenki);
                price['opt'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.opt_price * (+item.flag) * nacenki);
                price['sebest'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.sebestomost);

                result.materials[item.name] = {
                    order: +item.poryadok,
                    id: item.idTovar,
                    spis: item.procentSpisania,
                    type: item.edIzmer,
                    oprice: {
                        rozn: (+item.price).toFixed(2),
                        opt: (+item.opt_price).toFixed(2),
                        sebest: (+item.sebestomost).toFixed(2),
                    },
                    price,
                    quantity,
                    count: (+kolvo).toFixed(3)
                };
            }

            /*  if (name.includes('монтаж')) {
                  montage_item = item;
              }*/
        });

        if (title_addons.length > 0) {
            result.title = `${result.title} | ${title_addons.join(', ')}`;
        }

        result.price.rozn = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'rozn').toFixed(2);
        result.price.opt = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'opt').toFixed(2);
        result.price.sebest = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'sebest').toFixed(2);

        dispatch('item', result);
    }, 250);

    // Инициализируем отфильтрованные значения после загрузки данных
    fetchData.then(() => {
        initializeFilteredValues();
    });

    change();


    function chetn(x) {
        // Округляем вверх до целого
        let c = Math.ceil(x);

        // Если число уже чётное — возвращаем его
        if (c % 2 === 0) {
            return c;
        }

        // Иначе возвращаем следующее чётное
        return c + 1;
    }

    function ROUNDUP_TO_MULTIPLE(value, multiple) {
        if (multiple === 0) return value;

        // Округляем до ближайшего кратного
        return Math.round(value / multiple) * multiple;
    }


</script>

{#await fetchData}
    <div class="card-body">
        <div class="text-center">
            <p>Загрузка..</p>
        </div>
    </div>
{:then data}
    {@const is_manual = (tip.includes("Ручной") || tip.includes("Ламели"))}
    {@const
        dop_materials = data.result.filter((item) => is_manual ? [ 'Стеновой кронштейн','Удлинитель к кронштейну','Кронштейн потолочный'].includes(item.name.trim()) : ['Стеновой кронштейн','Удлинитель к кронштейну','Кронштейн потолочный','Кнопка для вальса А15', 'Пульт для вальса А13-6'].includes(item.name.trim()))}


    <div class="card-body" on:keyup={change} on:paste={change} on:change={change}>
        <div class="row d-flex">
            <div class="col-12  ">
                <div class="row">
                    <span class="badge-danger text-white small rounded-2 text-center text-uppercase"> { ($width > (options.recomend && options.recomend.width ? options.recomend.width : 4500) || $height > (options.recomend && options.recomend.height ? options.recomend.height : 6000)) ? 'Изделие с данным размером не подлежит гарантии' : '' }</span>
                </div>
                <div class="parent">

                    <div class="info">
                        <div class="alert alert-outline-danger">
                            Ткани могут отличаться по тону и текстуре от образцов в каталогах , возврату не подлежат , браком не является!
                            <br>
                            Минимальная расчетная площадь жалюзи шириной до 1м, считаются как 1м, высотой до 1,5м , считается как 1,5м
                        </div>
                    </div>

                    <div class="div1 form-group boxed">
                        <div class="input-wrapper">

                            <label class="form-label">1000 ≥ Шир., мм ≥ 3000</label>
                            <input type="number"
                                   class="form-control text-center  "
                                   step="1"
                                   min="500"
                                   max="5000"
                                   bind:value={$width} use:validate_int={$width}>
                        </div>
                    </div>

                    <div class="div2 form-group boxed">
                        <div class="input-wrapper">
                            <label class="form-label">500 ≥ Выс., мм ≥ 3000</label>
                            <input type="number"
                                   class="form-control text-center "
                                   step="1"
                                   min="300"
                                   max="5000"
                                   bind:value={$height} use:validate_int={$height}>
                        </div>
                    </div>

                    <div class="badgeVertik">
                        <span class="badge-danger text-white small rounded-2 text-center text-uppercase"> {  ($width > 3000 || $width < 1000 || $height > 3000 || $height < 500) ? 'Изделия не являются гарантийными. По всем вопросам рекомендуем обратиться к менеджеру!' : '' }</span>
                    </div>

                    <div class="div3 form-group boxed">
                        <div class="input-wrapper">
                            <label class="form-label">Тип, комплектация</label>
                            <select class="form-control form-select" bind:value={tip}
                                    on:change={() => handle_type(is_manual, dop_materials)}>
                                <option value="Ручной лев">Ручной лев</option>
                                <option value="Ручной прав">Ручной прав</option>
                                <option value="Ламели без карниза">Ламели без карниза</option>
                                <option value="Эл. 220В Wi-Fi лев">Эл. 220В Wi-Fi лев</option>
                                <option value="Эл. АКБ лев">Эл. АКБ лев</option>

                            </select>
                        </div>
                    </div>


                    <div class="div4 form-group boxed">
                        <div class="input-wrapper">
                            <label class="form-label text-white">_ </label>
                            <select class="form-control form-select" bind:value={t}>
                                {#if tip.includes("Ручной")}
                                    <option value="T1 (к упр)">T1 (к упр)</option>
                                    <option value="T2 (от упр)">Т2 (от упр)</option>
                                {/if}
                                <option value="T3 (от центра)">Т3 (от центра)</option>
                                {#if tip.includes("Ручной")}
                                    <option value="T4 (к упр)">T4 (к центру)</option>

                                {/if}
                            </select>
                        </div>
                    </div>


                    <div class="div5 form-group boxed">
                        <div class="input-wrapper">
                            <label class="form-label"> Ткань основа:</label>
                            <select class="form-control form-select" bind:value={tkan} on:change={handleTkanChange}>
                                {#each data.color_tape as value}
                                    <option value="{value}">{value}</option>
                                {/each}
                            </select>
                        </div>
                    </div>


                    <div class="div6 form-group boxed">
                        <div class="input-wrapper">
                            <label class="form-label text-white">_ </label>
                            <select class="form-control form-select" bind:value={tkan2} >
                                {#each filteredCornice as value}
                                    <option value="{value}">{value}</option>
                                {/each}
                            </select>
                        </div>
                    </div>


                    <div class="div7 form-group boxed">
                        <div class="input-wrapper">
                            <label class="form-label">Кол-во по бокам / Чередование</label>
                            <select class="form-control form-select" bind:value={kolvobok}>
                                <option value="нет">нет</option>
                                <option value="2+2">2+2</option>
                                <option value="3+3">3+3</option>
                                <option value="4+4">4+4</option>
                                <option value="5+5">5+5</option>
                                <option value="6+6">6+6</option>
                                <option value="7+7">7+7</option>
                                <option value="8+8">8+8</option>
                                <option value="0+2">0+2</option>
                                <option value="0+3">0+3</option>
                                <option value="0+4">0+4</option>
                                <option value="0+5">0+5</option>
                                <option value="0+6">0+6</option>
                                <option value="0+7">0+7</option>
                                <option value="0+8">0+8</option>
                                <option value="Чередование">Чередование</option>
                            </select>
                        </div>
                    </div>

                    {#if kolvobok !== 'нет'}

                        <div class="div8 form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">  {#if kolvobok !== 'Чередование'} Ткань бока:{:else} Ткань чередования: {/if}</label>
                                <select class="form-control form-select" bind:value={tkanboka}
                                        on:change={handleTkan2Change}>
                                    {#each data.color_tape as value}
                                        <option value="{value}">{value}</option>
                                    {/each}
                                </select>
                            </div>

                        </div>

                        <div class="div9 form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label text-white">_ </label>
                                <select class="form-control form-select" bind:value={tkanboka2}>
                                    {#each filteredCornice2 as value}
                                        <option value="{value}">{value}</option>
                                    {/each}
                                </select>
                            </div>
                        </div>

                    {/if}



                    <div class="div10 form-group boxed d-flex flex-column justify-content-center align-items-center">
                        <div class="text-center pt-3 ">
                            <label class="form-label">Количество ламелей всего:</label>
                            <div class="text-center">
                                    {
                                        Math.round(($width - 15) / 115) -1
                                    }

                            </div>
                        </div>


                        <img style="max-width: 200px;max-height: 200px;" src="{`/img/other/vals/${t.substring(0, 2).toLowerCase()}${ tip === 'Ручной прав' ? '-sp': ''}.jpg`}">
                        <div class="text-center">
                            <span class="form-label text-center">Площадь: : {
                            ($width < 1000) ?
                                (
                                    ($height < 1500) ? (1000 * 1500 / 1000000).toFixed(3) : (1000 * $height / 1000000).toFixed(3)
                                ) :
                                (
                                    ($height < 1500) ? ($width * 1500 / 1000000).toFixed(3) : ($width * $height / 1000000).toFixed(3)
                                )
                            } м.кв.</span>
                        </div>

                    </div>


                    <div class="div12">
                        <PodokonnikMaterialList list={dop_materials} bind:components={components}/>
                    </div>


                    <div class="div11 form-group boxed">
                        <div class="input-wrapper">
                            <div class="input-wrapper">
                                <label class="form-label">Примечание</label>
                                <textarea class="form-control" bind:value={$comment}></textarea>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>


{/await}
<style>
    .parent {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-auto-rows: auto;
        grid-column-gap: 5px;
        grid-row-gap: 0px;
        grid-template-areas:
                    "info info"
                    "width hight"
                    "badgeVertik badgeVertik"
                    "tip t"
                    "tkan tkan2"
                    "kolvobok kolvobok"
                    "tkanboka tkanboka2"
                    "dopMaterial dopMaterial"
                    "comment comment "
                    "pict pict"
                    "pict pict"
                    "pict pict"
                    "pict pict";



    }

    @media (min-width: 575.98px) {
        .parent {
            grid-template-columns: repeat(3, 1fr);
            grid-template-areas:
                    "info info info"
                    "width hight pict"
                    "badgeVertik badgeVertik pict"
                    "tip t  pict"
                    "tkan tkan2 pict"
                    "kolvobok tkanboka tkanboka2 "
                    "dopMaterial dopMaterial dopMaterial"
                    "comment comment comment";
        }
    }

    .info {
        grid-area: info;
    }
    .badgeVertik {
        grid-area: badgeVertik;
    }


    /* Шир*/
    .div1 {
        grid-area: width;
    }

    /*  Выс*/
    .div2 {
        grid-area: hight;
    }

    /*      Тип, комплектация*/
    .div3 {
        grid-area: tip;
    }

    /*T1*/
    .div4 {
        grid-area: t;
    }

    /*    Ткань основа*/
    .div5 {
        grid-area: tkan
    }

    /*  Ткань основа*/
    .div6 {
        grid-area: tkan2;
    }

    /*  Количество ламелей*/
    .div7 {
        grid-area: kolvobok;
    }

    /*   Ткань бока*/
    .div8 {
        grid-area: tkanboka;
    }

    /*   Ткань бока*/
    .div9 {
        grid-area: tkanboka2;
    }

    /* pict */
    .div10 {
        grid-area: pict
    }

    /* примечание */
    .div11 {
        grid-area: comment;
    }


    .div12 {
        grid-area: dopMaterial;
    }

    .div10 {
        display: flex;
        flex-direction: column;
        overflow: hidden;
    }

    .div10 .pict {
        align-items: center;
        justify-content: center;
        overflow: hidden;
        background-image: var(--var-picture);
        background-repeat: no-repeat;
        background-size: contain;
        background-position: center;
        height: calc(100% - 60px);
        width: 100%;
    }



</style>